import type { BookingDetailsAccommodationAddress } from '../../domain/types'

export function formatAccommodationAddress(address: BookingDetailsAccommodationAddress): string {
  const trim = (s: string | undefined | null) => s?.trim() || ''
  const postalAndCity = [address.postalCode, address.city].map(trim).filter(Boolean).join(' ')
  return [address.streetName, postalAndCity, address.region, address.country].map(trim).filter(Boolean).join(', ')
}
